import { STATUS_COLORS, STATUS_LABELS, formatFullTL, type StatusSlice } from './metrics';

/** Where the designer's portfolio currently sits — count and money per status. */
export function StatusBreakdown({
  slices, averageAmount, onSelect,
}: {
  slices: StatusSlice[];
  averageAmount: number;
  onSelect: () => void;
}) {
  const max = Math.max(1, ...slices.map(s => s.count));

  return (
    <div className="h-full flex flex-col">
      <ul className="flex-1 px-5 py-6 flex flex-col justify-center gap-5">
      {slices.map(slice => (
        <li key={slice.status}>
          <button
            type="button"
            onClick={onSelect}
            className="w-full text-left group"
            title="Teklif arşivini aç"
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-[11px] font-medium text-stone-600 group-hover:text-stone-900 transition-colors">
                {STATUS_LABELS[slice.status]}
              </span>
              <span className="text-[11px] font-normal text-stone-400 tabular-nums shrink-0">
                <span className="font-semibold text-stone-800">{slice.count}</span>
                {slice.total > 0 && <span> · {formatFullTL(slice.total)}</span>}
              </span>
            </div>
            <div className="mt-1.5 h-1.5 rounded-full bg-stone-100 overflow-hidden">
              <div
                className={`h-full rounded-full transition-all ${STATUS_COLORS[slice.status]}`}
                style={{ width: `${(slice.count / max) * 100}%` }}
              />
            </div>
          </button>
        </li>
      ))}
      </ul>

      <div className="px-5 py-3.5 border-t border-stone-100 flex items-baseline justify-between gap-2">
        <span className="text-[10px] font-medium uppercase tracking-wider text-stone-400">Ortalama Teklif Tutarı</span>
        <span className="text-xs font-semibold text-stone-900 tabular-nums">{formatFullTL(averageAmount)}</span>
      </div>
    </div>
  );
}
